import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { isEmpty, chain } from 'lodash';
import { captureException } from '@playbookux/playbook-web-core';
import { GET_COMPANY_MEMBERS } from './graphql';

const useCompanyMembersNames = (companyId, userId) => {
  const { data, loading, error } = useQuery(GET_COMPANY_MEMBERS, {
    variables: {
      companyId,
      hidden: false,
    },
    fetchPolicy: 'network-only',
    skip: !companyId,
  });

  if (error) {
    captureException('USE_COMPANY_MEMBERS_FAILED', error);
  }

  const users = useMemo(() => {
    const companyMembers = data?.companyMembers || [];
    if (isEmpty(companyMembers)) return [];

    return chain(companyMembers)
      .map((member) => ({
        id: member.user.id,
        name: `${member.user?.profile?.firstName || ''} ${member.user?.profile?.lastName || ''}`.trim(),
      }))
      .orderBy(
        [(v) => (v.id === userId ? 0 : 1), (v) => v.name.toLowerCase()],
        ['asc', 'asc'],
      )
      .value();
  }, [data, userId]);

  return {
    users,
    loading,
    error,
  };
};

export default useCompanyMembersNames;
